import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService } from '@app/_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private accountService: AccountService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status == 401) {
          this.accountService.logout();
        }
        if (err.status == 404) {
          console.log("errore 404")
        }
        // Preserve the original HttpErrorResponse instead of converting to string
        // This allows proper error handling downstream with status codes
        return throwError(() => err);
      })
    );
  }
}
